export function Articles() {
  const articles = [
    {
      title: "The Calm Approach: Turning Tension into Understanding",
      excerpt:
        "When emotions rise, our brain tends to go into protection mode. We stop listening, our voice gets louder, and suddenly the goal isn’t solving the issue — it’s winning.",
      image: "/images/article-1.jpg",
    },
    {
      title: "Why We Argue — and What We’re Really Trying to Say",
      excerpt:
        "We often think we argue because of what’s being said — the words, the tone, the topic. But in reality, most conflicts aren’t about what we’re discussing, they’re about what we need.",
      image: "/images/article-2.jpg",
    },
    {
      title: "It’s Not You vs. Me — It’s Us vs. the Problem",
      excerpt:
        "One of the biggest traps in any conflict is seeing the other person as the opponent. Once that happens, every word starts to sound like a threat.",
      image: "/images/article-3.jpg",
    },
  ];

  return (
    <section
      id="articles"
      className="container space-y-6 sm:space-y-8 md:space-y-12 lg:space-y-3xl mx-auto px-4 sm:px-6 md:px-10 lg:px-xl py-8 sm:py-12 md:py-16 lg:py-5xl"
    >
      <div className="space-y-2 sm:space-y-4">
        <h2 className="text-greyscale-default font-family-gabarito text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-bold leading-[32px] sm:leading-[40px] md:leading-[48px] lg:leading-3xl text-center">
          Latest Articles
        </h2>
        <p className="text-greyscale-subtle font-family-reddit-sans text-base sm:text-lg md:text-xl leading-[22px] sm:leading-[24px] md:leading-[28px] mx-auto text-center px-4">
          Read simple, science-based insights to help you understand yourself
          and others better.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-md">
        {articles.map((article) => (
          <div key={article.title} className="space-y-3 sm:space-y-l">
            <img
              src={article.image}
              alt={article.title}
              className="w-full max-h-[220px] sm:max-h-[280px] object-cover rounded-[20px]"
            />
            <div>
              <h3 className="h-auto sm:h-[64px] sm:max-h-[64px] line-clamp-2 text-greyscale-default font-family-gabarito text-xl sm:text-2xl font-medium leading-[28px] sm:leading-[32px] mb-1 sm:mb-2xs">
                {article.title}
              </h3>
              <p className="h-auto sm:h-[72px] sm:max-h-[72px] line-clamp-3 text-greyscale-subtle font-family-reddit-sans text-base sm:text-lg leading-[22px] sm:leading-[24px] mb-2 sm:mb-xs">
                {article.excerpt}
              </p>
              <button className="inline-flex text-accent-green hover:text-dark-green active:text-pastel-soft-green duration-300 transition-all ease-in-out font-family-gabarito text-base sm:text-lg font-medium leading-[24px] sm:leading-[28px] items-center gap-1 sm:gap-2xs">
                Read More <ChevronRightIcon />
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ChevronRightIcon({
  className,
  stroke,
}: {
  className?: string;
  stroke?: string;
}) {
  const defaultStroke = stroke || "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      className={className}
    >
      <path
        d="M0.750093 0.75C0.750093 0.75 6.75003 5.16893 6.75005 6.75005C6.75006 8.33116 0.750046 12.75 0.750046 12.75"
        stroke={defaultStroke}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
